import { render, staticRenderFns } from "./FinancialSettingsView.vue?vue&type=template&id=4b3fc99f&scoped=true&"
import script from "./FinancialSettingsView.vue?vue&type=script&lang=js&"
export * from "./FinancialSettingsView.vue?vue&type=script&lang=js&"
import style0 from "./FinancialSettingsView.vue?vue&type=style&index=0&id=4b3fc99f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3fc99f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
